import type { FC, SVGAttributes } from 'react';

import { PATH_WIDTH } from 'constants/map';
import { Direction } from 'types';

import { ReactComponent as Down } from './Down.svg';
import { ReactComponent as Left } from './Left.svg';
import { ReactComponent as Right } from './Right.svg';
import { ReactComponent as Up } from './Up.svg';

// Returns the direction icon based on type & adds passed props (to add extra attribues / override any styles)
export const DirectionIcon: FC<{ type: Direction } & SVGAttributes<SVGElement>> = ({ type, ...rest }) => {
    const style = { strokeWidth: PATH_WIDTH, stroke: 'transparent' };
    switch (type) {
        case Direction.DOWN:
            return <Down style={style} width={PATH_WIDTH} height={PATH_WIDTH} {...rest} />;
        case Direction.UP:
            return <Up style={style} width={PATH_WIDTH} height={PATH_WIDTH} {...rest} />;
        case Direction.LEFT:
            return <Left style={style} width={PATH_WIDTH} height={PATH_WIDTH} {...rest} />;
        case Direction.RIGHT:
            return <Right style={style} width={PATH_WIDTH} height={PATH_WIDTH} {...rest} />;
        default:
            return null;
    }
};
